import { useRef } from 'react'
import './App.css'
import styled from 'styled-components'
import Navbar from '../src/component/Navbar'
import HeroSection from '../src/component/HeroSection'
import image from '../src/assets/images/background.png'
import { Spacer } from './component/Spacer'
import Footer from './component/Footer'

const Wrapper = styled.div`
  min-height: 100vh;
`

function App() {
  const topRef = useRef(null)
  const roadmapRef = useRef(null)
  const faqRef = useRef(null)

  return (
    <div className="App">
      <Wrapper ref={topRef} style={{ backgroundImage: `url(${image})` }}>
        <Navbar tr={topRef} rr={roadmapRef} fr={faqRef} />
        <HeroSection sectionRef={roadmapRef} />
        <Footer />
      </Wrapper>
    </div>
  )
}

export default App
